import * as React from "react";
import { Icon } from "@mui/material";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useXoraiaValue } from "../../hooks/useXoraia";
import { TUseXElement, useXElement } from "../../hooks/useXElement";
import { USE_SELECTED_INDEX } from "../../hooks/useSelectedElement";
import { useSetRecoilState } from "recoil";
import { getValueOnBreakpoint } from "../../lib/getValueOnBreakpoint";
import { clickHandler } from "../../lib/clickHandler";
import { XElementConfig } from "../../utils/interfaces/Elements/XElement.interfaces";

import { isEqual } from "lodash";
import { generateSide } from "../../lib/generateSide";
import {
  IXIconProps,
  XIconProps,
} from "../../utils/interfaces/Elements/XIcon.interfaces";
import { generateBorder } from "../../lib/generateBorder";
import { generateRadius } from "../../lib/generateRadius";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XIcon: React.FC<XIconProps> = React.memo(
  ({ config = {} as XElementConfig }) => {
    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    const { env } = useXoraiaValue();

    // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
    const { xElement } = useXElement<TUseXElement<IXIconProps>>(config.index);

    // GARBING THE INDEX UPDATER FOR GENERAL USAGE
    const setSelectedElement = useSetRecoilState(USE_SELECTED_INDEX);

    // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
    if (!xElement || Object.keys(xElement).length === 0) return null;

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xElement;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXIconProps>(
      value as any,
      breakpoint
    );

    const devProps = {
      id: config.index,
      onClick: (e: any) => clickHandler(e, setSelectedElement, config.index),
    };

    const {
      icon,
      hoverColor,
      hoverFontSize,
      baseClassName,
      padding,
      margin,
      color,
      pack = "md",
      bgColor,
      border,
      borderRadius,
      ...sx
    } = valueAtBreakPoint;

    if (!icon && env === "prod") return null;

    return (
      <Icon
        {...(env === "dev" && devProps)}
        baseClassName={baseClassName}
        sx={{
          ...sx,
          color: color,
          bgcolor: bgColor,
          border: generateBorder(border),
          borderRadius: generateRadius(borderRadius),
          padding: generateSide("padding", padding),
          margin: generateSide("margin", margin),

          "&.material-icons": {
            fontSize: sx.fontSize || "inherit",
            color: color,
            lineHeight: "1em",
          },
          "&:hover": {
            color: hoverColor,
            fontSize: hoverFontSize,
          },
          lineHeight: "1em",
          letterSpacing: 0,
        }}
      >
        {icon ?? "mood"}
        {/* {iconComponent ? iconComponent(props) : icon || "mood"} */}
      </Icon>
    );
  },
  compareProps
);

export default XIcon;
